<app-launch-table
  [tableRowsControl]="formControl"
  [fields]="formControl.fields"
  [fieldCells]="formControl.fieldCells"
></app-launch-table>